<script>
  import { emitter } from '@/main.js';
  import storefront from '@/lib/storefront.js';
  import * as queries from '@/lib/queries.js';

  export default {
    name: 'ProductUpsellOptions',
    mounted() {
      emitter.on('updateAddButton', e => {
        let shouldUpdate = false;
        this.colorPid = e.parentId;
        if (this.upsellProductParentId !== e.parentId && e.upsellProductId?.value !== null) {
          this.upsellProductParentId = e.parentId;
          this.upsellProductId = e.upsellProductId?.value;
          this.pendingEvent = e;
          this.getProductDataById(this.upsellProductId, 1);
        }
        if (this.upsellProductParentId2 !== e.parentId && e.upsellProductId2?.value !== null) {
          this.upsellProductParentId2 = e.parentId;
          this.upsellProductId2 = e.upsellProductId2?.value;
          this.getProductDataById(this.upsellProductId2, 2);
        }

        if (this.upsellProductId !== undefined || this.upsellProductId2 !== undefined) {
          shouldUpdate = true;
        }
        const inStock = e.instock;
        const currentVariantId = e.variantId;
        if (shouldUpdate === true) {
          if (currentVariantId !== undefined) {
            this.enableUpsellOption = e.enableUpsellOption;
            this.baseProductPrice = e.variantPrice;
            const hasData = (this.currentUpsellOption === 1 && this.upProdData.length > 0) || (this.currentUpsellOption === 2 && this.upProdData2.length > 0);
            if (hasData) {
              this.setOptionData(this.currentUpsellOption, false);
              this.hasUpsellOptions = true;
              this.handleAvailableOptions();
            }
            this.variantAvailable = inStock;
            this.disabled = false;
            if (inStock === false) {
              this.variantAvailable = false;
              this.disabled = true;
            }
            if (hasData) {
              this.getSelectedUpsellVariantId();
            }
            if (this.updatedColor) {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.clickOptionHeader(this.currentUpsellOption);
                  this.updatedColor = false;
                }, 250);
              });
            }
          }
        } else {
          if (currentVariantId !== undefined) {
            this.hasUpsellOptions = false;
            this.disabled = true;
          }
        }
        this.handleErrorPadding();
      });
      emitter.on('pdp-color-updated', e => {
        if (e.pid !== this.colorPid) {
          this.defaultImages = e.images;
          this.updatedColor = true;
        }
      });
    },
    data() {
      return {
        colorPid: '',
        upsellProductParentId: '',
        upsellProductParentId2: '',
        upsellProductId: undefined,
        upsellProductId2: undefined,
        baseProductPrice: '',
        upsellProductPrice: '',
        upsellPriceDifference: null,
        variantAvailable: '',
        countryCode: window.Shopify.country,
        upsellOptionsName: '',
        variantData: [],
        upsellOptionValues: [],
        errorText: window.upsell_option_container_error_text,
        errorTextHeader: window.upsell_option_container_error_text_header,
        errorImage: window.upsell_option_container_error_image,
        hasUpsellOptions: false,
        upsellOptionsTitle: window.upsell_option_container_title,
        hasNotificationMessage: window.upsell_notification_enable,
        upsellNotificationMessage: window.upsell_notification_message,
        enableUpsellOption: false,
        selectedUpsellVariantId: '',
        selectedUpsellOptionName: '',
        imageNS: window.product_upsell_options_variant_ns || null,
        imageKey: window.product_upsell_options_variant_key || null,
        showUpsellHeaderButtons: window.show_upsell_header_buttons,
        upsellOptionsName1: window.product_upsell_options_name || null,
        upsellOptionsName2: window.product_upsell_options_name_2 || null,
        upProdData: [],
        upProdData2: [],
        defaultImages: [],
        currentUpsellOption: 1,
        disabled: false,
        updatedColor: false,
        currentVariantId: '',
        pendingEvent: null
      };
    },
    computed: {
      computedUpsellPriceMessage() {
        if (this.hasUpsellOptions && this.variantAvailable && this.upsellPriceDifference) {
          return '+$' + this.upsellPriceDifference;
        }
        return 'Unavailable';
      }
    },
    methods: {
      clickOptionHeader(option) {
        const headerOption = document.querySelector(`[data-header-option="${option}"]`);
        if (headerOption) {
          headerOption.click();
        }
      },
      handleErrorPadding() {
        const container = document.getElementById('product-upsell-options');
        if (!this.disabled) {
          container.classList.remove('unavailable');
        } else {
          container.classList.add('unavailable');
        }
      },
      getUpsellOptionsName() {
        this.variantData.forEach(variant => {
          if (variant.node.selectedOptions[2].value !== null) {
            this.upsellOptionsName = variant.node.selectedOptions[2].name;
          }
        });
      },
      getSelectedUpsellVariantId() {
        if (this.selectedUpsellOptionName) {
          const colorSwatches = document.querySelectorAll('.color-variant-options .color-swatches.selected');
          const sizeOptions = document.querySelectorAll('.size-variant-options .option2.selected');

          const colorSwatchesSelected = colorSwatches[0]?.getAttribute('data-color');
          const sizeOptionsSelected = sizeOptions[0]?.getAttribute('data-size').replace('s', '');

          let selectedVariantId = '';
          this.variantData.forEach(variant => {
            if (variant.node.selectedOptions[0].value === colorSwatchesSelected) {
              if (variant.node.selectedOptions[1].value === sizeOptionsSelected) {
                if (variant.node.selectedOptions[2].value === this.selectedUpsellOptionName) {
                  selectedVariantId = variant.node.id;
                  this.upsellOptionsName = variant.node.selectedOptions[2].name;
                }
              }
            }
          });

          if (this.selectedUpsellVariantId !== this.getVarinatIDfromBase(selectedVariantId)) {
            this.selectedUpsellVariantId = this.getVarinatIDfromBase(selectedVariantId);
            setTimeout(() => {
              this.emitSelectedUpsellVariantId();
            }, 300);
          }
        }
      },
      emitSelectedUpsellVariantId() {
        emitter.emit('updateUpsellVariantId', {
          upsellVariantId: this.selectedUpsellVariantId,
          upsellVariantPrice: this.upsellProductPrice
        });
      },
      removeSelectedUpsellOption() {
        this.selectedUpsellOptionName = '';
        this.selectedUpsellVariantId = '';
      },

      clickSelectedOption() {
        if (this.selectedUpsellOptionName) {
          const selectedOption = document.querySelector(`.upsell-option-value[data-value="${this.selectedUpsellOptionName}"]`);
          setTimeout(() => {
            if (selectedOption) {
              if (selectedOption.classList.contains('unavailable')) {
                this.clickSelectedOption();
              } else {
                //selectedOption.click();
              }
            }
          }, 500);
        }
      },

      closePersonalizationTab() {
        const containters = document.querySelectorAll('.upsell-options-container');
        containters.forEach(container => {
          container.classList.add('closed-container');
        });
      },
      removePersonalizationImages() {
        emitter.emit('replace-variant-image', this.defaultImages);
      },
      uncheckCheckbox() {
        const checkbox = document.getElementById('add-personalization-checkbox');
        const icon = document.getElementById('upsell-checkmark-icon');
        if (checkbox) checkbox.checked = false;
        if (icon) icon.classList.remove('checked');
      },
      checkCheckbox() {
        const checkbox = document.getElementById('add-personalization-checkbox');
        const icon = document.getElementById('upsell-checkmark-icon');
        if (checkbox) checkbox.checked = true;
        if (icon) icon.classList.add('checked');
      },
      handleCheckBox() {
        const checkbox = document.getElementById('add-personalization-checkbox');
        if (!this.hasUpsellOptions) {
          this.uncheckCheckbox();
          return;
        }

        if (checkbox.checked) {
          this.checkCheckbox();
          const container = document.querySelector('.upsell-options-container');
          container.classList.remove('closed-container');
          this.selectFirstOption();
        } else {
          this.uncheckCheckbox();
          this.removePersonalizationItem();
          this.closePersonalizationTab();
          this.removePersonalizationImages();
          this.$nextTick(() => {
            this.selectFirstColorOption();
          });
        }
      },
      selectFirstOption() {
        const allOptions = document.querySelectorAll('.upsell-option-value');
        if (allOptions.length > 0) {
          allOptions[0].click();
        }
      },
      selectFirstColorOption() {
        const colorSwatches = document.querySelectorAll('.color-variant-options .color-swatches.selected');
        if (colorSwatches.length > 0) {
          colorSwatches[0].click();
        }
        this.setSelectedOptionHeader(this.currentUpsellOption);
        this.selectDefaultOption();
        this.updatedColor = false;
      },
      getVarinatIDfromBase(str) {
        const decodedStr = str;
        const vid = decodedStr.replace('gid://shopify/ProductVariant/', '');
        return vid;
      },
      getProductDataById(id, data) {
        if (id) {
          const cleanId = id.replace('gid://shopify/Product/', '');
          const variables = {
            query: 'id:' + cleanId,
            countryIso2: this.countryCode
          };
          if (this.imageNS && this.imageKey) {
            variables.imageNS = this.imageNS;
            variables.imageKey = this.imageKey;
          }
          storefront
            .request(queries.productMasterByIds, {
              variables
            })
            .then(response => {
              this.getOptionValues(response, data);
              if (data === this.currentUpsellOption) {
                this.setOptionData(data, false);
                this.hasUpsellOptions = true;
                this.handleAvailableOptions();
                this.getSelectedUpsellVariantId();
              }
              if (this.pendingEvent) {
                this.baseProductPrice = this.pendingEvent.variantPrice;
                this.variantAvailable = this.pendingEvent.instock;
                this.disabled = !this.pendingEvent.instock;
                this.pendingEvent = null;
              }
              this.handleErrorPadding();
            })
            .catch(error => {
              console.error('ProductUpsellOptions: Error fetching upsell product data:', {
                error: error?.message || error,
                stack: error?.stack,
                response: error?.response,
                fullError: error
              });
            });
        }
      },
      getOptionValues(response, data) {
        if (data === 1) {
          this.upProdData = response.data.products.edges[0].node.variants.edges;
        } else {
          this.upProdData2 = response.data.products.edges[0].node.variants.edges;
        }
      },
      getUpsellProductImages(option) {
        const variant = this.variantData.find(variant => variant.node.selectedOptions[2].value === option);
        return variant?.node?.upsellImage?.references?.edges || [];
      },
      getColorSwatchImages(option) {
        const imageName = window.cdn + this.handleize(option) + '.png';
        return imageName;
      },
      handleize(str) {
        return str
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '');
      },
      addPersonalization(option) {
        if (this.hasUpsellOptions) {
          const allOptions = document.querySelectorAll('.upsell-option-value');
          if (allOptions.length > 0) {
            allOptions.forEach(option => {
              option.classList.remove('selected');
            });
            const selectedOption = document.querySelector(`.upsell-option-value[data-value="${option}"]`);
            selectedOption.classList.add('selected');
            this.checkCheckbox();
          }
          this.selectedUpsellOptionName = option;
          this.getSelectedUpsellVariantId();
          const images = this.getUpsellProductImages(option);
          if (images.length > 0) {
            emitter.emit('replace-variant-image', images);
          }
        }
      },
      removePersonalizationItem() {
        this.removeSelectedUpsellOption();
        const allOptions = document.querySelectorAll('.upsell-option-value');
        if (allOptions.length > 0) {
          allOptions.forEach(option => {
            option.classList.remove('selected');
          });
        }
      },
      setupVariantData() {
        this.variantData.forEach(variant => {
          if (variant.node.selectedOptions[2]) {
            const details = variant.node;
            if (!this.upsellOptionValues.includes(details.selectedOptions[2].value)) {
              this.upsellOptionValues.push(details.selectedOptions[2].value);
              this.upsellProductPrice = details.price.amount;
              this.upsellPriceDifference = this.upsellProductPrice - this.baseProductPrice;
            }
          }
        });
      },

      handleAvailableOptions() {
        const containters = document.querySelectorAll('.upsell-options-container');
        containters.forEach(container => {
          container.classList.remove('unavailable');
        });
      },

      getPersonalizationText() {
        const textMessage = this.upsellOptionsTitle.split('|');
        let personalizationText = '';
        if (textMessage[0] !== undefined) {
          personalizationText = textMessage[0] + this.upsellOptionsName;
        }
        if (textMessage[1] !== undefined) {
          personalizationText = personalizationText + textMessage[1];
        }

        return personalizationText;
      },
      setSelectedOptionHeader(data) {
        const headerOptions = document.querySelectorAll('.upsell-option-name');
        headerOptions.forEach(option => {
          option.classList.remove('selected');
        });
        const headerOption = document.querySelector(`[data-header-option="${data}"]`);
        if (headerOption) {
          headerOption.classList.add('selected');
        }
      },
      selectDefaultOption() {
        const availableOptions = document.querySelectorAll('.upsell-option-value');
        // try to select the currently selected option
        if (this.selectedUpsellOptionName) {
          const selectedOption = document.querySelector(`.upsell-option-value[data-value="${this.selectedUpsellOptionName}"]`);
          if (selectedOption) {
            selectedOption.click();
          } else {
            // select the first available option if exists

            if (availableOptions.length > 0) {
              this.$nextTick(() => {
                availableOptions[0].click();
              });
            }
          }
        }
      },
      setOptionData(data, selectDefault = false) {
        this.variantData = [];
        this.upsellOptionValues = [];
        if (data === 1) {
          this.variantData = this.upProdData;
        } else {
          this.variantData = this.upProdData2;
        }
        this.currentUpsellOption = data;
        this.$nextTick(() => {
          this.setupVariantData();
          this.getUpsellOptionsName();
          this.setSelectedOptionHeader(data);
          if (selectDefault) {
            this.$nextTick(() => {
              this.selectDefaultOption();
            });
          }
        });
      }
    }
  };
</script>

<template>
  <template v-if="this.enableUpsellOption">
    <div class="upsell-options-container-add-personalization-container" @click="handleCheckBox()">
      <div class="upsell-options-container-add-personalization-container-text" :class="this.disabled ? 'unavailable' : ''">
        <p class="add-personalization-text gt-p__small">
          <label for="add-personalization-checkbox" class="checkbox-container">
            <span id="upsell-checkmark-icon"></span>
            <input type="checkbox" id="add-personalization-checkbox" />

            {{ getPersonalizationText() }}
            <span v-html="'(' + computedUpsellPriceMessage + ')'"></span>
          </label>
        </p>
      </div>
    </div>
    <div class="upsell-options-container closed-container">
      <div class="upsell-options-container-header" :class="this.disabled ? 'unavailable' : ''" v-if="this.showUpsellHeaderButtons">
        <p data-header-option="1" class="gt-p__small upsell-option-name" @click="setOptionData(1, true)">
          {{ this.upsellOptionsName1 }}
        </p>
        <p data-header-option="2" class="gt-p__small upsell-option-name" @click="setOptionData(2, true)">
          {{ this.upsellOptionsName2 }}
        </p>
      </div>
      <div class="upsell-options-container-error" v-if="this.disabled">
        <img :src="this.errorImage" />
        <div class="error-text-container">
          <p v-html="this.errorTextHeader" class="error-text-header gt-p__small"></p>
          <p v-html="this.errorText" class="error-text gt-p__small"></p>
        </div>
      </div>
      <div class="option-title-container" :class="this.disabled ? 'unavailable' : ''">
        <p class="option-title gt-p__small">
          <span class="option-name gt-p__small" v-html="this.upsellOptionsName"></span>:
          <span class="gt-p__small" v-html="this.selectedUpsellOptionName"></span>
        </p>
      </div>
      <div v-for="option in this.upsellOptionValues" :key="option" :class="`upsell-option-value ${option} ${this.selectedUpsellOptionName === option ? 'selected' : ''} ${this.disabled ? 'unavailable' : ''}`" :data-value="option" @click="addPersonalization(option)">
        <img :src="getColorSwatchImages(option)" />
        <div class="upsell-option-value-text gt-p__small" :data-upsell-option-value="this.currentUpsellOption">
          {{ option }}
        </div>
      </div>
      <div class="upsell-notification-message" v-if="this.hasNotificationMessage && !this.disabled">
        <p class="gt-p__small" v-html="this.upsellNotificationMessage"></p>
      </div>
    </div>
  </template>
</template>
